import React, { useState } from 'react';
import { MessageSquare } from 'lucide-react';
import FeedbackModal from './FeedbackModal';
import { useAuth } from '../contexts/AuthContext';

const FloatingFeedbackButton: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { user } = useAuth();

  // Only show feedback button for authenticated users
  if (!user) {
    return null;
  }

  return (
    <>
      <button
        onClick={() => setIsModalOpen(true)}
        className="group fixed bottom-6 right-6 z-50 flex items-center bg-[#F16D34] hover:bg-[#FF986A] text-white p-3 font-bold border-2 border-[#161E54] shadow-neo transition-all hover:shadow-neo-lg hover:-translate-y-1 rounded-full"
        aria-label="Give Feedback"
      >
        <MessageSquare className="w-5 h-5 flex-shrink-0" />
        <span className="max-w-0 overflow-hidden opacity-0 group-hover:max-w-xs group-hover:opacity-100 group-hover:ml-2 transition-all duration-300 ease-in-out whitespace-nowrap">
          Feedback
        </span>
      </button>
      
      <FeedbackModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default FloatingFeedbackButton;

